var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"outer-page"},[_c('div',{staticClass:"title"},[_c('selectPane',{attrs:{"monitorInfo":_vm.monitorInfo}})],1),_c('div',{ref:"myEchart",staticClass:"echarts-pane",staticStyle:{"width":"100%","height":"300px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }